{
  "title": "Казино кешбэк",
  "yourLevel": "ВАШ УРОВЕНЬ",
  "completed": "ЗАВЕРШЕНО",
  "locked": "ЗАКРЫТО",
  "xpLabel": "Опыт",
  "xpRule": "Расчёт опыта: €1 ставка = {{xp}} очков опыта",
  "cashback": "Кешбэк {{pct}}%",
  "cashbackMax": "Кешбэк {{lo}}% - {{hi}}%",
  "daily": "Ежедневно",
  "everyDays": "Раз в {{days}} дн.",
  "active": "Актив: AZN {{amount}}",
  "claim": "ЗАБРАТЬ",
  "howTitle": "Как это работает?",
  "how1": "Играйте в любимые слоты и игры",
  "how2": "Получайте опыт и повышайте уровень",
  "how3": "Получайте кешбэк и награды",
  "lockedNote": "Для уровня «{{name}}» нужно больше опыта",
  "loginHint": "Войдите для XP, кешбэка и вывода",
  "login": "Войти",
  "history": "История",
  "historyEmpty": "Пока нет записей.",
  "claimTitle": "Забрать кешбэк",
  "claimAmount": "Сумма: {{amount}} AZN",
  "claimNote": "На реальный баланс. Wagering: 0x.",
  "cancel": "Отмена",
  "confirm": "Подтвердить",
  "congrats": "Поздравляем!",
  "newLevel": "Новый VIP уровень: {{name}}",
  "continue": "Продолжить",
  "infoBody": "Только реальные казино-ставки дают XP и кешбэк. Бонус, спорт и демо не входят. Ожидание 24ч и минимум 1 AZN.",
  "close": "Закрыть",
  "maxNote": "VIP MAX — XP не копится. Кешбэк по категориям.",
  "level_1": "Медь",
  "level_2": "Бронза",
  "level_3": "Серебро",
  "level_4": "Золото",
  "level_5": "Рубин",
  "level_6": "Сапфир",
  "level_7": "Алмаз",
  "level_8": "VIP УРОВЕНЬ",
  "maintenance": "Техпауза — вывод временно закрыт.",
  "rulesTitle": "ПРАВИЛА",
  "lockedShort": "ЗАКРЫТО",
  "rulesIntro": "“VIP Cashback” Kazinosuna xoş gəlmisiniz! Sistem səviyyənizə, oyun növlərinə və mərc müntəzəmliyinə görə real pulun bir hissəsini geri almaq imkanı verir. Nə qədər aktiv oynasanız, bir o qədər tez-tez və daha çox keşbek əldə edirsiniz.",
  "rulesWhatTitle": "VIP Cashback nədir",
  "rulesWhat": "Keşbek — oyun aktivliyinə görə xərclənmiş vəsaitin bir hissəsinin geri qaytarılmasıdır. Dinamikdir və səviyyəniz yüksəldikcə dəyişir.",
  "rulesLevelsTitle": "Cashback səviyyələri",
  "rulesLevels1": "Sistemdə 8 səviyyə var. Növbəti səviyyəyə keçmək üçün təcrübə xalı toplamaq lazımdır.",
  "rulesLevels2": "Yeni səviyyə keşbek faizini və götürmə tezliyini artırır.",
  "rulesXpTitle": "Təcrübə xalının hesablanması",
  "rulesXpNote": "Hər səviyyədə €1 mərc = müvafiq XP. Saytda balans və keşbek AZN-dir; XP əmsalları eyni qaydada tətbiq olunur (1 AZN mərc = eyni XP).",
  "rulesCbTitle": "Cashback necə işləyir",
  "rulesCb1": "1–7 səviyyələrdə (Mis–Almaz) keşbek uduzulmuş mərclərə görə hesablanır.",
  "rulesCbFormula": "Keşbek = (Mərclərin cəmi − Qazanılan məbləğ) × keşbek %",
  "rulesCb2": "Dövr üzrə nəticə müsbətdirsə, keşbek 0 olur.",
  "rulesCb3": "VIP MAX-da keşbek hər real mərcə görə kateqoriya faizi ilə verilir: Slot 0.25%, Lotereya 0.20%, Canlı kazino 0.10%, Masa oyunları 0.05%.",
  "rulesImportantTitle": "Bilmək vacibdir",
  "rulesImportant1": "Bonus balanslı, idman və demo mərclər XP/keşbek yaratmır.",
  "rulesImportant2": "24 saat gözləmə və minimum 1 AZN götürmə qaydası qüvvədədir.",
  "rulesImportant3": "Keşbek birbaşa real balansa köçürülür (0x wagering).",
  "rulesXp1": "1-ci səviyyə “Mis”: Hər €1 mərc üçün oyunçu 100 təcrübə xalı alır",
  "rulesXp2": "2-ci səviyyə “Bürünc”: Hər €1 mərc üçün oyunçu 150 təcrübə xalı alır",
  "rulesXp3": "3-ci səviyyə “Gümüş”: Hər €1 mərc üçün oyunçu 200 təcrübə xalı alır",
  "rulesXp4": "4-ci səviyyə “Qızıl”: Hər €1 mərc üçün oyunçu 250 təcrübə xalı alır",
  "rulesXp5": "5-ci səviyyə “Yaqut”: Hər €1 mərc üçün oyunçu 300 təcrübə xalı alır",
  "rulesXp6": "6-ci səviyyə “Safir”: Hər €1 mərc üçün oyunçu 350 təcrübə xalı alır",
  "rulesXp7": "7-ci səviyyə “Almaz”: Hər €1 mərc üçün oyunçu 400 təcrübə xalı alır",
  "rulesXp8": "8-ci səviyyə “VIP MAX”: sonuncu səviyyə, təcrübə xalı verilmir"
}
